"use client"

import { SidebarProvider, SidebarInset, SidebarTrigger } from "@/components/ui/sidebar"
import { Separator } from "@/components/ui/separator"

interface DashboardShellProps {
  children: React.ReactNode
  sidebar: React.ReactNode
}

export function DashboardShell({ children, sidebar }: DashboardShellProps) {
  return (
    <SidebarProvider>
      {sidebar}
      {/* text-foreground: marketing @layer base sets body { color: charcoal }
          (light theme); the inset's bg-background is dark, so without an
          explicit foreground everything lacking a text-* utility (e.g. the
          SidebarTrigger icon, page h1s) inherits dark-on-dark. */}
      <SidebarInset className="text-foreground">
        <header className="flex h-14 shrink-0 items-center gap-2 border-b px-4">
          <SidebarTrigger className="-ml-1" />
          <Separator orientation="vertical" className="mr-2 !h-4" />
        </header>
        <main className="flex-1 overflow-y-auto">
          <div className="container mx-auto p-4 md:p-6">{children}</div>
        </main>
      </SidebarInset>
    </SidebarProvider>
  )
}
